import React from 'react';
import { connect } from 'react-redux';
import { formatDate, fromNow }  from './../utils';

const BookingOpenAlert = (props) => {
  const { eventType, closeTime, openTime } = props;
  if(!eventType) {
    return <div />;
  }
  let className = '';
  let message = '';
  switch (eventType) {
    case 'parking_closed':
      className = 'message-alert__danger';
      message = `Parking closed ${formatDate(closeTime)} (${fromNow(closeTime)})`;
      break;
    case 'parking_will_open':
      className = 'message-alert__info';
      message = `Parking opens ${formatDate(openTime)} (${fromNow(openTime)})`;
      break;
    case 'parking_open':
      className = 'message-alert__success';
      message = `Reservations open until ${formatDate(closeTime)} (${fromNow(closeTime, true)})`;
      break;
  }

  return (
    <div className={`message-alert ${className}`}>
        <i className="fa fa-clock-o"/>
        &nbsp;{message}
    </div>
  );
};

const mapStateToProps = (state) => {
  const { eventType, closeTime, openTime } = state.session;
  return { eventType, closeTime, openTime };
};

export default connect(mapStateToProps)(BookingOpenAlert);



// WEBPACK FOOTER //
// ./src/containers/BookingOpenAlert.js